import { useNavigate } from "react-router-dom";
import { FavoriteProjectsIds, TRecommendedProjectData } from "../../../types";
import { useState } from "react";
import { api } from "../../../api";
import { IoArrowBack } from "react-icons/io5";
import { Badge } from "@chakra-ui/react";
import ActionIcon from "../../../components/ActionIcon";
import SaveItemSVG from "../../../assets/Icons/SaveItem";

enum ProjectStatus {
  UNDER_VALIDATION = "Under Validation",
}

const TitleSection = ({
  projectData,
}: {
  projectData: TRecommendedProjectData & { isAggregated?: boolean };
}) => {
  const navigate = useNavigate();
  const [itemSaved, setItemSaved] = useState<boolean>(projectData?.isSaved ?? false);

  const handleSaveItem = () => {
    if (itemSaved) {
      unSaveProject();
    } else {
      saveProject();
    }
  };

  const saveProject = async () => {
    if (!projectData?.id) return;
    const body = {
      mangrove_recommendation: projectData?.id,
    };
    const saveStatus = await api
      .post<FavoriteProjectsIds>("/user/favourites", body)
      .then((savedList) => savedList.data.mangrove_recommendations.includes(projectData?.id));
    setItemSaved(saveStatus);
  };

  const unSaveProject = async () => {
    if (!projectData?.id) return;
    const saveStatus = await api
      .delete<FavoriteProjectsIds>("/user/favourites/mangrove_recommendations/" + projectData?.id)
      .then((savedList) => savedList.data.mangrove_recommendations.includes(projectData?.id));
    setItemSaved(saveStatus);
  };

  const goBack = () => {
    navigate(-1);
  };

  // fix this shit in near future

  const getTitle = () => {
    if (projectData?.isAggregated) {
      return `${projectData?.adm2} - ${projectData?.type}`;
    } else return `${projectData?.adm2 || projectData?.adm_name} - ${projectData?.type}`;
  };
  return (
    <div className="flex w-full items-center justify-between gap-4">
      <div className="space-x-2">
        <button onClick={goBack} className="focus:outline-none">
          <IoArrowBack className="text-primaryPurple-100" />
        </button>
        <span className="text-xl font-medium text-black">
          {/*{projectData?.name || `${search?.name} ${projectData.name}`}*/}
          {getTitle()}
        </span>
        <Badge content={ProjectStatus.UNDER_VALIDATION} />
      </div>
      <ActionIcon
        className={`flex h-10 w-10 items-center justify-center rounded-full border-0 p-2 shadow-md ${
          itemSaved ? "bg-blue-400" : ""
        }`}
        variant="outlined"
        onClick={handleSaveItem}
        icon={<SaveItemSVG fill={itemSaved ? "white" : ""} />}
      />
    </div>
  );
};

export default TitleSection;
